import {
    AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges,
    ViewChild
} from '@angular/core';
import {PageService} from "../../../core/services/page.service";
import { ToastrService } from 'ngx-toastr';
import {EventService} from "../../../core/services/event.service";
import { NgForm } from '@angular/forms';
import {Angulartics2} from "angulartics2";
import {NationalTeamsService} from '../../../core/services/national-teams.service';
import {ProgressService} from "../../../core/services/progress.service";
import {HybridToolsService} from "../../../core/services/hybrid-tools.service";

@Component({
    selector: 'app-page-options',
    templateUrl: './page-options.component.html',
    styleUrls: ['../edit-page.component.scss']
})
export class PageOptionsComponent implements OnChanges, OnInit, AfterViewInit {
    @Input() model: any = {};
    @Input() isTeam: number;
    @Input() isNationalTeam: boolean;
    @Input() donationsAmounts: any = [];
    @ViewChild('f') form: NgForm;
    @Output() onInit: EventEmitter<NgForm> = new EventEmitter();
    @Input() isPastItemPage: boolean;
    @Input() cssClass: boolean;

    displayOptions: any = {};
    numbers: any = [1, 2, 3, 4, 5, 6];

    state: any = {
        isSubmitted: false
    };

    onOffOptions: any[] = [{"label":"On", "value": "1"}, {"label": "Off", "value": "0"}];
    yesNoOptions: any[] = [{"label":"Yes", "value": true}, {"label": "No", "value": false}];
    showHideOptions: any[] = [{"label":"Show", "value": "1"}, {"label": "Hide", "value": "0"}];

    constructor(
        private pageService: PageService,
        private toastr: ToastrService,
        public eventService: EventService,
        private angulartics2: Angulartics2,
        private nationalTeamsService: NationalTeamsService,
        private progressService: ProgressService,
        private hybridToolsService: HybridToolsService) {
        this.eventService.onEventChange.subscribe(r => {
            this.eventService.getDonationAmounts(this.getFundraiserId())
                .subscribe(res => {
                    this.donationsAmounts = res.Fundraiser[0].fundraiserDonationAmountRangeTypes
                });
        });
    }

    ngOnInit() {
        this.mapDisplayOptions();
    }

    ngAfterViewInit() {
        this.onInit.emit(this.form);
    }

    ngOnChanges(changes: SimpleChanges) {
        this.mapDisplayOptions();
    }

    getFundraiserId() {
        if (this.isNationalTeam) {
            return this.nationalTeamsService.selectedNationalTeam.fundraiser.fundraiserId;
        } else if (this.isTeam) {
            return this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraiserId;
        } else {
            return this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraiserId;
        }
    }

    mapDisplayOptions() {
        if (this.model) {
            if (this.model.dedicationType === null) {
                this.model.dedicationType = '0';
            }
            this.model.displayOptions.map(item => {
                if (item.optionValue === null) {
                    this.displayOptions[item.optionType] = '0';
                } else {
                    this.displayOptions[item.optionType] = item.optionValue;
                }
            });
        }
    }

    onFormSubmit(f: any) {
        this.progressService.startProgress(false);
        this.state.isSubmitted = true;
        if (!this.form.valid) {
            this.form.form.updateValueAndValidity();
            window.scrollTo(0, 0);
            this.progressService.stopProgress(false);
            return;
        } else {
            this.model.displayOptions = [];
            this.model.fullUrl = this.model.baseUrl + this.model.urlKey;
            if(!this.isNationalTeam) {
                for (const key in this.displayOptions) {
                    const value = this.displayOptions[key];
                    const obj = {
                        optionType: key,
                        optionValue: value
                    };
                    this.model.displayOptions.push(obj);
                }
            } else {
                this.displayOptions = null;
            }

            this.pageService.updatePageOptions(this.model.pageID, this.model).subscribe(res => {
                this.form.form.markAsPristine();
                this.toastr.success(res['message']);
                this.angulartics2.eventTrack.next({
                    action: 'Option Change',
                    properties: {category: 'Fundraising Pages: Options'}
                });
                if (this.isNationalTeam) {
                    this.pageService.getNationalTeamPage(this.nationalTeamsService.selectedNationalTeam.nationalTeamPageId, true)
                        .subscribe(() => {
                            this.progressService.stopProgress(false);
                        });
                } else if (this.isTeam) {
                    this.pageService.getTeamPage(this.eventService.selectedEvent.participantId, this.eventService.selectedEvent.gql.Participant[0].team.teamId, true)
                        .subscribe(() => {
                            this.progressService.stopProgress(false);
                        });
                } else {
                    this.pageService.getUserPage(this.eventService.selectedEvent.participantId, true)
                        .subscribe(() => {
                            this.progressService.stopProgress(false);
                        });
                }
            }, err => {
                var error = JSON.parse(err['error']);
                if(error && !!error.fieldErrors) {
                    var errors = [];
                    errors.push(error.fieldErrors.map(function (item, index) {
                        return item.message;
                    }));
                    this.toastr.error(errors.join(', '));
                } else {
                    this.toastr.error(error.message);
                }
                this.progressService.stopProgress(false);
            });

        }
    }

    checkNewsFeedExists() {
        if(this.displayOptions['SHOW_NEWS_FEED'] === '1'
            && (!this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraiserNewsFeeds || this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraiserNewsFeeds.length === 0)) {
            this.displayOptions['SHOW_NEWS_FEED'] = '0';
            this.toastr.error('There is no content for the news feed, Please use the Tab "Manage News feed" in order to add a news feed content before enabling this option.');
            return;
        }
    }

    urlKeyMaxLength() {
        var baseUrl = this.model.fullUrl.substr(0, this.model.fullUrl.lastIndexOf('/') + 1);
        var maxLength = 329 - baseUrl.length;
        if(maxLength > 212) {
            return 212;
        }
        return maxLength;
    }
}
